const marked = require("marked");
const moment = require('moment-timezone');

exports.isSmartPhone = (userAgent = "") => {
    const smartPhonesReg = /iPhone|iPod|iPad|Android|Windows Phone|BlackBerry|Symbian/
    return smartPhonesReg.test(userAgent)
}

exports.createInquiryUrl = ({ shopId, orderNumber }) => {
  const reactEnv_shopIdMs = process.env.REACT_APP_INQUIRY_SHOPID_MS || '';
  const reactEnv_orderNumberMs = process.env.REACT_APP_INQUIRY_ORDERNUMBER_MS || '';
  const env_shopIdMs = process.env.INQUIRY_SHOPID_MS || '';
  const env_orderNumberMs = process.env.INQUIRY_ORDERNUMBER_MS || '';
  const shopIdMs = reactEnv_shopIdMs ? reactEnv_shopIdMs : env_shopIdMs;
  const orderNumberMs = reactEnv_orderNumberMs ? reactEnv_orderNumberMs : env_orderNumberMs;
  const orderNumberBaseURL = 'https://ask.step.rakuten.co.jp/inquiry-form/index.phtml?page=order-inquiry&language_type=0&fidmmy=1&act=input&bot=0&redirect=0';
  const shopIdBaseURL = 'https://ask.step.rakuten.co.jp/inquiry-form/?page=simple-inquiry-top&act=login&bot=0&redirect=0';
  if (orderNumber && orderNumberMs) return `${orderNumberBaseURL}&ms=${orderNumberMs}&on=${orderNumber}`;
  if (shopId && shopIdMs) return `${shopIdBaseURL}&ms=${shopIdMs}&shop_id=${shopId}`;
  return '';
}

exports.isProduction = (hostname) => {
  const hostnameReg = /service-sb|standby|preview|stg|localhost|127.0.0.1/
  return !hostnameReg.test(hostname)
}

exports.changeToCustomHTML = (markdownText='') => {
  marked.setOptions({mangle: false})
  const renderer = new marked.Renderer({mangle: false});
  renderer.link = (href, title, text) => {
    const squareBtn = `<div class="squareBtn"><div><a href="${href}" title="${title}" target="_blank" onClick="window.open(this.href,this.target).focus();return false;">${text}</a></div></div>`;
    const simpleLink = `<a href="${href}">${text}</a>`;
    const mailLink = `<a href="mailto:${href}">${text}</a>`;
    const defaultLink = `<a href="${href}" target="_blank" onClick="window.open(this.href,this.target).focus();return false;">${text}</a>`;
    if(href.startsWith('mailto:')) return text;

    const elSet = { faq: squareBtn, direct: squareBtn, tel: simpleLink, mail: mailLink };
    return elSet[title] || defaultLink;
  };
  return marked(markdownText, { renderer, mangle:false });
}

exports.convertZoning = (param='') => {
  const weekNumber = moment().tz('Asia/Tokyo').weekday();
  const zoningArray = [
    { 'sxd5': 'A', 'sxd8': 'B', },
    { '46e7': 'A', '46e8': 'B', },
    { '34a1': 'A', '34a9': 'B', },
    { '12a2': 'A', '12a8': 'B', },
    { '32v1': 'A', '32v5': 'B', },
    { '67b2': 'A', '67bb': 'B', },
    { 'rf45': 'A', 'rf67': 'B', },
  ];
  const weekdayJSON = zoningArray[weekNumber] || '';
  if (!weekdayJSON) return '';
  return weekdayJSON[param] || '';
}